import React from "react";

const SystemRequirements = () => {
  return (
    <div className="flex flex-col lg:flex-row justify-center">
      <div className=" text-white py-32">
        <div className="py-4 max-w-3xl mx-auto bg-slate-900 p-8 rounded-lg shadow-lg">
          <h1 className="text-3xl font-bold mb-4">Technical Requirements</h1>
          <p className="mb-8">
            To view the live webcast, users need a modern web browser like
            Chrome, Firefox, Safari, or Edge capable of HTML5 video. Speakers
            and an Internet connection (preferably high-speed) are also required
            to fully experience the webcast.
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">
              Note to Systems Administrators{" "}
            </h2>
            <p className="mb-2">
              Corporate firewall settings can sometimes block live webcasts.
            </p>
            <p className="mb-4">
              The video player uses the HLS protocol (HTTP, port 80) by default.
              Most firewalls will not block this unless streaming video has been
              deliberately disallowed.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default SystemRequirements;
